// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "backButton-1sp-T";
export { _1 as "__esModule", _2 as "backButton" }
export default { "__esModule": _1, "backButton": _2 }
